<template>
    <div class="pr-5">
        <editor-js
            :data="data.areas[0].content"
            @save="(d) => save(0, d)"
        />

        <div class="field-frame">
            <div class="columns">
                <div class="column">
                    <b-field label="District">
                        <b-select expanded disabled placeholder="Applicant selects a district...">
                        </b-select>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="School">
                        <b-select expanded disabled placeholder="Schools load from the selected district...">
                        </b-select>
                    </b-field>
                </div>
            </div>
            <b-switch v-model="data.required">Response Required</b-switch>
        </div>

        <editor-js
            :data="data.areas[1].content"
            @save="(d) => save(1, d)"
        />

        <advanced-options :data="data"/>
    </div>
</template>

<script>
    import EditorJs from "../EditorJs.vue";
    import AdvancedOptions from "./AdvancedOptions.vue";
    import {v4 as uuidv4} from "uuid";

    export default {
        props: ['data'],
        components: {EditorJs, AdvancedOptions},
        data: function() {
            return {
                advanced: false
            };
        },
        methods: {
            save(area, data) {
                this.data.areas[area].content = data;
            }
        },
        created() {
            if (!this.data.areas) {
                this.data.areas = [
                    {areas: 1, content: null, attributes: {}},
                    {areas: 2, content: null, attributes: {}},
                ];

                this.data.required = false;
                this.data.id = uuidv4();
            }
        }
    };
</script>
